import React, { useState, useEffect } from 'react';
import {
  CITIZENSHIP_TYPE, CITIZENSHIP_TYPE_LIST, GENDER_OPTIONS, IDENTITY_TYPE_LIST, REGISTRATION_TYPE_LIST,
} from '../../../../configs';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import PersonDTO from '../../../../dto/PersonDTO';
import FIOForm from './FIOForm';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import { getDeepValue } from '../../../../utils/utils';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import IndividualEntrepreneurDTO from '../../../../dto/IndividualEntrepreneurDTO';
import { required } from '../../../../utils/validation';
import AddressInput from '../../../../components/fields/Address/AddressInput';

export default function PersonForm(props) {
  const {
    prefix = '',
    control,
    setValue,
    getValues,
    watch = () => {},
    isPrivatePerson = false,
    isIndividualEntrepreneur = false,
    formMeta,
    applicantType,
    isPreview = false,
  } = props;
  const [citizenship, setCitizenship] = useState('');

  const dto = new PersonDTO();
  const attributes = dto.getAttributesByName();
  const ipAttr = new IndividualEntrepreneurDTO().getAttributesByName();

  const firstAddress = `${prefix}${isIndividualEntrepreneur ? 'office_address' : 'address'}`;
  const secondAddress = `${prefix}${isIndividualEntrepreneur ? 'address' : 'fact_address'}`;

  useEffect(() => {
    const subscription = watch(values => {
      if (getValues(secondAddress) !== getValues(firstAddress) && getValues(`${prefix}isMatch`)) {
        setValue(secondAddress, getValues(firstAddress));
      }
      setCitizenship(getDeepValue(values, `${prefix}citizenship`));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  let identityTypeList = [
    IDENTITY_TYPE_LIST[0],
    IDENTITY_TYPE_LIST[1],
    IDENTITY_TYPE_LIST[2],
    IDENTITY_TYPE_LIST[3],
    IDENTITY_TYPE_LIST[4],
    IDENTITY_TYPE_LIST[5],
    IDENTITY_TYPE_LIST[6],
    IDENTITY_TYPE_LIST[7],
  ];
  if (citizenship === CITIZENSHIP_TYPE.FOREIGN_CITIZEN) {
    identityTypeList = [
      IDENTITY_TYPE_LIST[8],
      IDENTITY_TYPE_LIST[9],
      IDENTITY_TYPE_LIST[10],
      IDENTITY_TYPE_LIST[5],
    ];
  }
  if (citizenship === CITIZENSHIP_TYPE.STATELESS_PERSON) {
    identityTypeList = [
      IDENTITY_TYPE_LIST[9],
      IDENTITY_TYPE_LIST[10],
      IDENTITY_TYPE_LIST[11],
      IDENTITY_TYPE_LIST[12],
      IDENTITY_TYPE_LIST[5],
    ];
  }

  function previewFormForPrivatePerson() {
    return (
      <>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.inn}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <FIOForm {...props} />
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.phone}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.email}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            label="Адрес регистрации"
            component={AddressInput}
            dtoObject={isPrivatePerson ? {
              name: 'address',
              type: Number,
              validators: [required],
              labelKey: 'address',
              couldBeNull: true,
            } : isPrivatePerson}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            label="Адрес проживания"
            component={AddressInput}
            dtoObject={attributes.office_address}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={isPrivatePerson ? {
              name: 'citizenship',
              type: Number,
              validators: [required],
              labelKey: 'citizenship',
              couldBeNull: true,
            } : attributes.citizenship}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={CITIZENSHIP_TYPE_LIST}
          />
        </Row>
      </>
    );
  }

  function fullFormForPrivatePerson() {
    return (
      <>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.inn}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <FIOForm {...props} />
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.phone}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.email}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            label="Адрес регистрации"
            component={AddressInput}
            dtoObject={isPrivatePerson ? {
              name: 'address',
              type: Number,
              validators: [required],
              labelKey: 'address',
              couldBeNull: true,
            } : isPrivatePerson}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            label="Адрес проживания"
            component={AddressInput}
            dtoObject={attributes.office_address}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            component={CustomSelectInput}
            dtoObject={attributes.identity_type}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={identityTypeList}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.identity_series}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.identity_number}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.identity_issue_date}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.identity_issuer}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.birth_date}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.gender}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={GENDER_OPTIONS}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={isPrivatePerson ? {
              name: 'citizenship',
              type: Number,
              validators: [required],
              labelKey: 'citizenship',
              couldBeNull: true,
            } : attributes.citizenship}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={CITIZENSHIP_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            component={CustomSelectInput}
            dtoObject={attributes.registration_type}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={REGISTRATION_TYPE_LIST}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.place_of_birth}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.snils}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.applicant_identity_files}
            variant="material"
            namePrefix="media."
            // labelPrefix={prefix}
            // disabled={disabled}
            multiple
          />
        </Row>
      </>
    );
  }

  function previewFormForIndividualEntrepreneur() {
    return (
      <>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.inn}
            variant="material"
            namePrefix={prefix}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={ipAttr.ogrn}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <FIOForm {...props} />
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.phone}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.email}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={AddressInput}
            dtoObject={attributes.address}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            label="Адрес проживания"
            component={AddressInput}
            dtoObject={attributes.office_address}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={isPrivatePerson ? {
              name: 'citizenship',
              type: Number,
              validators: [required],
              labelKey: 'citizenship',
              couldBeNull: true,
            } : attributes.citizenship}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={CITIZENSHIP_TYPE_LIST}
          />
        </Row>
      </>
    );
  }

  function fullFormForIndividualEntrepreneur() {
    return (
      <>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.inn}
            variant="material"
            namePrefix={prefix}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={ipAttr.ogrn}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <FIOForm {...props} />
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.phone}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.email}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={AddressInput}
            dtoObject={attributes.address}
            variant="material"
            namePrefix={prefix}
            // disabled={
            //       disabled || (
            //         (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3 && applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR)
            //           || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5)
            //           || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8)
            //       )
            //   }
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            label="Адрес проживания"
            component={AddressInput}
            dtoObject={attributes.office_address}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            component={CustomSelectInput}
            dtoObject={attributes.identity_type}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={identityTypeList}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.identity_series}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.identity_number}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.identity_issue_date}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.identity_issuer}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            withLabel
            dtoObject={attributes.birth_date}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.gender}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={GENDER_OPTIONS}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={isPrivatePerson ? {
              name: 'citizenship',
              type: Number,
              validators: [required],
              labelKey: 'citizenship',
              couldBeNull: true,
            } : attributes.citizenship}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={CITIZENSHIP_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            component={CustomSelectInput}
            dtoObject={attributes.registration_type}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
            withLabel
            options={REGISTRATION_TYPE_LIST}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.place_of_birth}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.snils}
            variant="material"
            namePrefix={prefix}
            // disabled={disabled}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.applicant_identity_files}
            variant="material"
            namePrefix="media."
            // labelPrefix={prefix}
            // disabled={disabled}
            multiple
          />
        </Row>
      </>
    );
  }

  return isIndividualEntrepreneur
    ? !isPreview ? fullFormForIndividualEntrepreneur() : previewFormForIndividualEntrepreneur()
    : !isPreview ? fullFormForPrivatePerson() : previewFormForPrivatePerson();
}
